import React from 'react';
import { motion } from 'framer-motion';
interface GalleryImage {
  url: string;
  alt: string;
}
const images: GalleryImage[] = [{
  url: 'https://cdn.magicpatterns.com/uploads/7jaijN8myS4xBjA2g2LnVW/IMG_3685.webp',
  alt: 'Steinvilla mit Pool'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3oWHNxvXH6eKAkWiUrzdTg/IMG_3686.webp',
  alt: 'Infinity Pool mit Sonnenuntergang'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/bgRTcmVagNcha985nGgWCw/IMG_3687.webp',
  alt: 'Überdachte Terrasse mit Lounge'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/odk81fdTZGRRuSSeTg73UW/IMG_3688.webp',
  alt: 'Balkon mit Panoramablick'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/rYJZHg3Bx8jyA5a1vPsKQr/IMG_3681.jpg',
  alt: 'Pool mit Garten und Bergblick'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/4TQc98ATeCzg2Lhr7YGwyV/IMG_3682.jpg',
  alt: 'Poolbereich mit Sonnenliegen'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/8fhZakEZrRwqmk1w18n3zw/IMG_3683.jpg',
  alt: 'Wohnzimmer mit Steinwand und Kamin'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/qdWuXAnza7qwKbaSLqtA7b/IMG_3684.jpg',
  alt: 'Küche und Essbereich'
}];
function GalleryImage({
  image,
  index
}: {
  image: GalleryImage;
  index: number;
}) {
  // Alternating pattern: every pair of rows, first image is large, then small, then small, then large
  const isLarge = index % 4 === 0 || index % 4 === 3;
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.7,
    delay: index % 4 * 0.15
  }} className={`relative overflow-hidden rounded-2xl shadow-lg group ${isLarge ? 'md:col-span-2 aspect-[16/10]' : 'aspect-[4/5]'}`} data-id="element-38">
      <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-39" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-40" />
    </motion.div>;
}
export function PhotoGallery() {
  return <section className="py-20 md:py-32 px-4 md:px-8 bg-[#faf6f1]" data-id="element-41">
      <div className="max-w-6xl mx-auto" data-id="element-42">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-43">
          <p className="text-[#8b7355] text-sm uppercase tracking-[0.2em] mb-3" data-id="element-44">
            Ein Vorgeschmack
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#2c1810] font-medium" data-id="element-45">
            Was uns erwartet
          </h2>
        </motion.div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-46">
          {images.map((image, index) => <GalleryImage key={index} image={image} index={index} data-id="element-47" />)}
        </div>
      </div>
    </section>;
}